import moment from 'moment'
import {Booking} from './booking.service'
import {Entity} from './entity.service'
import {TimezoneService} from "@/services/timezone.service";
import {KeycloakService} from "@/services/keycloak.service";
import {LocationService} from "@/services/location.service";
import {flatten} from "lodash";
import {Location} from "@/services/location.service";

const { Constants } = require("../constants")
const { ApiService, ApiError } = require("./api.service")

class Group {

    constructor(group) {
        this.id = group ? group.id : undefined
        this.name = group ? group.name : undefined
        this.spotRows = group && group.spotRows ? group.spotRows.toString() : "0"
        this.spotColumns = group && group.spotColumns ? group.spotColumns.toString() : "0"
        this.entities = group && group.entities ? group.entities.map(o => new Entity(o)) || [] : []
        this.spots = group && group.spots ? group.spots.map(o => new Spot(o)) || [] : []
        this.location = group && group.location ? new Location(group.location) : null
    }

    getEntities() {
        var entities = []
        for (const entity of this.entities) {
            entities.push(entity.name)
        }

        return entities.length > 0 ? entities.join(', ') : '-'
    }

    setSelectedSpots(spots) {
        for (const spot of this.spots) {
            const selectedSpot = spots.filter(o => o.id == spot.id)
            spot.selected = selectedSpot.length > 0
        }
    }

    getSortedSpots() {
        const availableSpots = parseInt(this.spotRows) * parseInt(this.spotColumns)
        const sortedSpots = []

        for (let i = 0; i < availableSpots; i++) {
            const spot = this.spots.filter(o => o.index == i)
            sortedSpots.push(spot.length == 1 ? spot[0] : new Spot())
        }

        return sortedSpots
    }

    getSelectedSpots() {
        const selectedSpots = this.spots.filter(spot => spot.selected)
        const spots = []
        for (const spot of selectedSpots) {
            spots.push(spot.label)
        }

        return spots.length > 0 ? spots.join(', ') : '-'
    }
}

class Spot {
    constructor(spot) {
        this.id = spot ? spot.id : undefined
        this.label = spot ? spot.label : undefined
        this.index = spot ? spot.index : undefined
        this.active = spot ? spot.active : false
        this.overbookable = spot ? spot.overbookAble : true
        this.hardwareId = spot ? spot.hardwareId : undefined
        // extended properties
        this.booking = spot && spot.booking ? new Booking(spot.booking) : undefined
        this.nextBooking = spot && spot.nextBooking ? new Booking(spot.nextBooking) : undefined
        this.selected = false
    }

    getNextOrEndingBookingDate() {
        if (this.nextBooking == undefined) {
            if (this.booking == undefined) {
                return
            }
            return moment(this.booking.entity.endDate).format('HH:mm')
        }
        return moment(this.nextBooking.entity.startDate).format('HH:mm')
    }
}

class GroupDropdown {
    constructor(group) {
        this.id = group ? group.id : undefined
        this.value = group ? group.name : undefined
        this.checked = true
    }
}

class SpotDropdown {
    constructor(spot) {
        this.id = spot ? spot.id : undefined
        this.value = spot ? spot.label : undefined
        this.checked = spot ? spot.checked || false : undefined
    }
}

const GroupService = {

    getGroups: async function() {
        try {
            const endpoint = `${Constants.ENDPOINT_GROUPS}`
            const response = await ApiService.get(endpoint)
            if (KeycloakService.isWarehouseManager()) {
                const locations = await LocationService.getLocations()
                const locationGroups = locations?.map(l => l?.groups?.map(group => group.id))
                return response.data.filter(g => flatten(locationGroups).includes(g.id))
            }
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    },

    getGroup: async function(groupId) {
        try {
            const endpoint = `${Constants.ENDPOINT_GROUPS}/${groupId}`
            const response = await ApiService.get(endpoint)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    },

    getGroupBookings: async function(groupId, date, location) {
        try {
            const fromDate = moment(date).toISOString()
            const toDate = moment(date).endOf('day').toISOString()

            const endpoint = `${Constants.ENDPOINT_GROUP_BOOKINGS}/${groupId}?fromdate=${fromDate}&todate=${toDate}}`
            const response = await ApiService.get(endpoint)
            // correct the  timezone
            let spots = response.data.spots
            for (let i = 0; i < spots.length; i ++ ) { // for every spot
                if (spots[i].hasOwnProperty('nextBooking')) { // check if there is an upcoming booking
                    let booking = spots[i].nextBooking
                    spots[i].nextBooking = TimezoneService.correctTimezoneDifferenceDown(booking, location) // correct the timezone
                }
                if (spots[i].hasOwnProperty('booking')) {
                    let booking = spots[i].booking
                    spots[i].booking = TimezoneService.correctTimezoneDifferenceDown(booking, location) // correct the timezone
                }
            }
            response.data.spots = spots
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    }
}

export { GroupService, Group, GroupDropdown, Spot, SpotDropdown }
